import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("../pages/home/page"));
const KandidatenPage = lazy(() => import("../pages/kandidaten/page"));
const ProgrammPage = lazy(() => import("../pages/programm/page"));
const StadtratswahlPage = lazy(() => import("../pages/stadtratswahl/page"));
const KreistagwahlPage = lazy(() => import("../pages/kreistagswahl/page"));
const LinksPage = lazy(() => import("../pages/links/page"));
const UeberUnsPage = lazy(() => import("../pages/ueber-uns/page"));
const ImpressumPage = lazy(() => import("../pages/impressum/page"));
const NotFoundPage = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/kandidaten",
    element: <KandidatenPage />,
  },
  {
    path: "/programm",
    element: <ProgrammPage />,
  },
  {
    path: "/stadtratswahl",
    element: <StadtratswahlPage />,
  },
  {
    path: "/kreistagswahl",
    element: <KreistagwahlPage />,
  },
  {
    path: "/links",
    element: <LinksPage />,
  },
  {
    path: "/ueber-uns",
    element: <UeberUnsPage />,
  },
  {
    path: "/impressum",
    element: <ImpressumPage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export default routes;
